import React from 'react';
import { observer } from 'mobx-react';

import { Layout, Drawer, Switch, Button, Icon, Input, Checkbox, Row, Col, Alert, Affix, Collapse, Radio, List, Badge } from 'antd';

import { FilterTopBar, ScreenshotTopBar, SearchTopBar } from './TopBars';
import { FilterPanel } from './FilterPanel';
import { ScreenshotPanel } from './ScreenshotPanel';
import { SearchPanel } from './SearchPanel';

import QueueAnim from 'rc-queue-anim';

const { Header, Content, Sider } = Layout;

@observer
class Sidebar extends React.Component {

	onSearchChange = (e) => {
		console.log(e.target.value);
		this.props.stateStore.setSearchValue(e.target.value);
	}

	renderTopBar() {
		let stateStore = this.props.stateStore;

		if (stateStore.panelMode == 'filter'){
			return <FilterTopBar key='filterTopBar' stateStore={stateStore} onSearchChange={this.onSearchChange} />;
		}
		else if (stateStore.panelMode == 'screenshot'){
			return <ScreenshotTopBar key='screenshotTopBar' stateStore={stateStore} />;
		}
		else if (stateStore.panelMode == 'search'){
			return <SearchTopBar key='searchTopBar' stateStore={stateStore} onSearchChange={this.onSearchChange} />;
		}
		return null;
	}

	renderPanel() {
		let stateStore = this.props.stateStore;

		if (stateStore.panelMode == 'filter'){
			return <FilterPanel key='filterPanel' stateStore={stateStore} />;
		}
		else if (stateStore.panelMode == 'screenshot'){
			return <ScreenshotPanel key='screenshotPanel' stateStore={stateStore} />;
		}
		else if (stateStore.panelMode == 'search'){
			return <SearchPanel key='searchPanel' stateStore={stateStore} />;
		}
		return null;
	}


	render() {
		let stateStore = this.props.stateStore;

		return (
		<Sider theme="light" trigger={null} width="300"
		collapsible
		collapsed={this.props.collapsed}
		onCollapse={this.props.onCollapse}
		breakpoint="md"
		collapsedWidth={0}
		style={{ height: '100vh', left: 0 }}>
			<div className="scrollable-container" 
			ref={node => {
				this.container = node;
			}} style={{ height: '100%', overflow: 'auto' }}>
				<div className="logo" />

				<Affix target={() => this.container}>
					{ this.renderTopBar() }
				</Affix>

				<QueueAnim duration={200} delay={[200,0]}>
				{ this.renderPanel() }
				</QueueAnim>

			</div>
		</Sider>
		);
	}
}

export { Sidebar };

